import { http, http2, http3, v1http, httpbffnew } from '@/plugins/api'
import { decryptResponse } from '@/helpers/responseEncryption'
import { token } from '@/services/token'

export const login = (credentials) => {
  //const url = 'http://127.0.0.1:8000/api/v1/login'
  const url = '/auth/login'
  const headers = {
    Accept: 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  }

  return http.post(url, credentials, {
    headers
  }).then((response) => {
    // debugger;
    // console.log('Login encrypted response:', response)
    const afterDecrypted = decryptResponse(response);
    // console.log('Login decrypted response:', afterDecrypted)
    return afterDecrypted;
  })
}

export const checkAuth = () => {
  const url = '/auth/auth_check'
  const headers = {
    Accept: 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  }

  return http.get(url, {
    headers,
  })
}

export const logout = () => {
  const url = '/auth/logout'
  const headers = {
    Accept: 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  }

  return http.get(url, {
    headers,
  })
}

export const register = (data) => {
  const url = '/auth/signup'
  const headers = {
    Accept: 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  }

  return http.post(url, data, {
    headers,
  })
}

export const registerNasabah = (data) => {
  const url = '/transaction-composer/nasabah/registration'
  const headers = {
    Accept: 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  }

  return http.post(url, data, {
    headers,
  })
}

export const registerMaxi = (data) => {
  const url = '/transaction-composer/maxi/registration'
  const headers = {
    'Content-Type': 'application/vnd.api+json',
  }

  return http.post(url, data, {
    headers,
  })
}

export const registerAxi = (data) => {
  const url = '/transaction-composer/axi/registration'
  const headers = {
    'Content-Type': 'application/vnd.api+json',
  }

  return http.post(url, data, {
    headers,
  })
}

export const getProfileNasabah = (userId, accessTokenType, accessToken) => {
  const url = `/profile/customers/${userId}`
  const headers = {
    'Authorization': `${accessTokenType} ${accessToken}`
  }

  return http.get(url, {
    headers
  })
}

export const getProfileByUserId = (userId, accessTokenType, accessToken) => {
  const url = `/getProfile?userId=${userId}`
  const headers = {
    'Authorization': `${accessTokenType} ${accessToken}`
  }
  return httpbffnew.get(url, {
    headers
  })
}

export const getProfileAxi = (userId) => {
  const url = `/profile/profiles/${userId}?include=detail-axis.accounts.banks,detail-axis.npwps,addresses`

  return http.get(url)
}

export const getProfileAxiByUserId = (userId, accessTokenType, accessToken) => {
  //const url = `http://127.0.0.1:8000/api/v1/profiles?filter[user_id]=${userId}&include=detail-axis.accounts.banks%2Cdetail-axis.npwps%2Caddresses`
  const url = `/profile/profiles?filter[user_id]=${userId}&include=detail-axis.accounts.banks,detail-axis.npwps,addresses`
  const headers = {
    'Authorization': `${accessTokenType} ${accessToken}`
  }
  return http.get(url, {
    headers
  }).then(async (response) => {
    const afterDecrypted = await decryptResponse(response, accessToken)
    return afterDecrypted;
  }).catch(error => {
    throw error;
  });
}

export const getDetailAxi = (userId) => {
  const url = `/profile/detail-axis/${userId}`

  return http.get(url)
}

export const getDetailAxiByNomorAxi = (nomorAxi) => {
  const url = `/profile/detail-axis?filter[nomor_axi_id]=${nomorAxi}`

  return http.get(url)
}

export const getDetailProfileByDetailAxiId = (detailAxiId) => {
  const url = `/profile/axi/detail?id=${detailAxiId}`

  return http.get(url)
}

export const getDetailInsentif = (nomorAxiId) => {
  const url = `/reward/existing/point?profile_id=${nomorAxiId}`

  return http.get(url)
}

export const forgotPassword = (data) => {
  const url = '/auth/password/email'
  const headers = {
    Accept: 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  }

  return http.post(url, data, {
    headers,
  })
}

export const resetPassword = (data) => {
  const url = '/auth/password/reset'
  const headers = {
    Accept: 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  }

  return http.post(url, data, {
    headers,
  }).catch((error) => {
    return (error.response.data);
  })
}

export const tokenValidation = (data) => {
  const url = '/auth/password/token-validation'
  const headers = {
    Accept: 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  }

  return http.post(url, data, {
    headers,
  }).catch((error) => {
    return (error.response.data);
  })
}

export const getBanks = () => {
  const url = '/profile/banks'
  return http3.get(url)
}

export const updateProfile = (profileId, payload) => {
  const url = `/bff/axi/edit`

  const formData = new FormData()

  Object.keys(payload).forEach((key) => {
    formData.append(key, payload[key])
  })

  const headers = {
    'Content-Type': 'application/vnd.api+json',
  }

  return v1http.post(url, formData, {
    headers,
  })
}

export const updateAvatar = (profileId, payload) => {
  
  //const url = `http://127.0.0.1:8000/api/v1/profiles/${profileId}`
  const url = `profile/profiles/${profileId}`

  let formData = new FormData()

  Object.keys(payload).forEach(key => {
    formData.append(key, payload[key])
  })

  return http.patch(url, formData).then(async (response) => {
    const afterDecrypted = await decryptResponse(response, token.accessToken);
    return afterDecrypted;
  }).catch((error) => {
    throw error;
  })
}

export const changePassword = (payload) => {
  const url = '/auth/password/change'
  return http.post(url, payload)
}

export const getAxiProfileToken = () => {
  const url = `/bff/axi/profile`

  return v1http.get(url)
}

export const getstatusverified = () => {
  const url = `/bff/eventFlagUpdateAxi`

  return v1http.get(url)
}

